<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  @if(auth.IsAuthorizedUser()){
  <app-authorizeview></app-authorizeview>
  }
  @else {
  <app-unauthorizeview></app-unauthorizeview>
  }
</div>
<div style="z-index: 1200" class="toast-container  position-fixed bottom-0 end-0 p-3">
  @if(notify.show) {<ngb-toast [class.white]="notify.messageType === 'DANGER'"
    [ngClass]="{ 'bg-success': notify.messageType === 'SUCCESS','bg-danger': notify.messageType === 'DANGER' }"
    [header]="notify.title" [autohide]="true">
    {{ notify.message }} </ngb-toast>}
</div>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="square-spin">
  <div class="d-flex justify-content-center" >
    <div class="spinner-border  text-primary" role="status">

    </div>
  </div>
  <p style="font-size: 20px; color: white">Please wait...</p>
</ngx-spinner>
<alert #alertContent></alert>
